<template>
	<div class="center_member_box">
		<center-title>{{$t("message.cmember.title")}}</center-title>
		<member-table v-model="search" :prop-attr="sortAttr" :order="sortMode" :current-page="page.current_page"
			:page-count="page.last_page" @handleSearch="handleSearch" @selection-change="handleSelectionChange"
			@handleSort="handleSort" @current-change="handleCurrent" @handleModify="getMemberDetail"
			@handleDelete="handleDel" @handle-export="handleExport" @handle-batch-del="handleBatchDel"
			@batch-del="handleBatchDel">
		</member-table>
		<member-dialog @handleModify="handleModify" @handleClose="handleCloseDialog">
			<template #form>
				<member-form ref="editForm" :key="editForm" :member-detail="member_detail"
					:data-character="character_list" :data-company="parent_company" :data-department="department_list"
					:data-address="address_list" :data-examine="examine_list" :data-jurisdiction="jurisdiction"
					:data-balance="balance" @selected-company="selectedCompany"
					@selected-department="selectedDepartment" @handle-assign="handleAssign">
					<!-- ID -->
					<template #memberId="{ uId }">
						<el-form-item :label="$t('message.cmember.form2')">
							<el-input :value="uId" class="member-form-input" disabled>
							</el-input>
						</el-form-item>
					</template>
					<!-- 登录名 -->
					<template #uName="{ form }">
						<el-form-item :label="$t('message.cmember.form3')">
							<el-input v-model="form.u_name" class="member-form-input" clearable disabled>
							</el-input>
						</el-form-item>
					</template>
					<!-- 密码 -->
					<template #password="{ form }">
						<el-form-item :label="$t('message.cmember.form4')" prop="up_pwd">
							<el-popover placement="right-start" trigger="focus">
								<ul class="member-form-popover">
									<li>{{$t("message.cmember.rule8")}}</li>
									<li>{{$t("message.cmember.rule5")}}</li>
									<li>{{$t("message.cmember.rule6")}}</li>
									<li>{{$t("message.cmember.rule7")}}</li>
								</ul>
								<el-input v-model="form.up_pwd" class="member-form-input" slot="reference" show-password
									clearable>
								</el-input>
							</el-popover>
						</el-form-item>
					</template>
					<!-- 已选地址 -->
					<template #selectedAddress="{ form }">
						<el-form-item :label="$t('message.cmember.form11')" v-if="[2,3].includes(form.character_id)">
							<el-table :data="member_detail.address" max-height='200' tooltip-effect="dark">
								<!-- 姓名 -->
								<el-table-column :label="$t('message.cmember.address1')" prop="consignee" width="250"
									show-overflow-tooltip>
								</el-table-column>
								<!-- 地址 -->
								<el-table-column :label="$t('message.cmember.address2')" prop="address"
									show-overflow-tooltip>
								</el-table-column>
								<!-- 地址 -->
								<el-table-column label="操作" prop="address" show-overflow-tooltip>
									<template v-slot="{ row }">
										<el-button size="mini" type="text" @click="selectedAddressDel(row.address_id)">
											<span>{{$t("public.delBtn")}}</span>
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-form-item>
					</template>
					<!-- 选择地址备注 -->
					<template #addressRemark>
						<div class="member-form-input-remarks">
							{{$t("message.cmember.addressRemarks")}}
						</div>
					</template>
				</member-form>
			</template>
		</member-dialog>
		<member-add>
			<template #addForm>
				<member-form :key="addForm" :member-detail="{}" :data-character="character_list"
					:data-company="parent_company" :data-department="department_list" :data-address="address_list"
					:data-examine="examine_list" :data-jurisdiction="jurisdiction" :data-balance="balance"
					:handle-validate-uname="handleValidateUname" @selected-company="selectedCompany"
					@selected-department="selectedDepartment" @handle-assign="handleAssign">
					<!-- 选择等级 -->
					<template #character="{ form }">
						<el-form-item :label="$t('message.cmember.form1')" prop="character_id">
							<el-radio-group v-model="form.character_id" size="mini">
								<el-radio v-for="(item, index) in character_list" :key="index"
									:label="item.character_id" border>
									<span>{{item.charactername}}</span>
								</el-radio>
							</el-radio-group>
						</el-form-item>
					</template>
					<!-- 登录名 -->
					<template #uName="{ form }">
						<el-form-item :label="$t('message.cmember.form3')" prop="u_name">
							<el-popover placement="right-start" trigger="focus">
								<ul class="member-form-popover">
									<li>{{$t("message.cmember.rule1")}}</li>
									<li>{{$t("message.cmember.rule2")}}</li>
									<li>{{$t("message.cmember.rule3")}}</li>
									<li>{{$t("message.cmember.rule4")}}</li>
								</ul>
								<el-input v-model="form.u_name" class="member-form-input" slot="reference" clearable>
								</el-input>
							</el-popover>
						</el-form-item>
					</template>
					<!-- 密码 -->
					<template #password="{ form }">
						<el-form-item :label="$t('message.cmember.form4')" prop="pwd">
							<el-popover placement="right-start" trigger="focus">
								<ul class="member-form-popover">
									<li>{{$t("message.cmember.rule5")}}</li>
									<li>{{$t("message.cmember.rule6")}}</li>
									<li>{{$t("message.cmember.rule7")}}</li>
								</ul>
								<el-input v-model="form.pwd" class="member-form-input" slot="reference" show-password
									clearable>
								</el-input>
							</el-popover>
						</el-form-item>
					</template>
					<!-- 按钮 -->
					<template #submit="{ form, rule }">
						<el-button type="primary" @click="handleSubmit(form, rule)">
							<span>{{$t("message.cmember.addTitle")}}</span>
						</el-button>
					</template>
				</member-form>
			</template>
		</member-add>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex';
	import {
		tableRouterView
	} from "@/utils/publicMethod.js";

	export default {
		mixins: [tableRouterView],
		computed: mapState({
			power: state => state.user.power,
			user_info: state => state.user.user_info,
			member_list: state => state.user.member_list,
			member_detail: state => state.user.member_detail,
			page: state => state.user.page,
			character_list: state => state.user.character_list,
			parent_company: state => state.user.parent_company,
			department_list: state => state.user.department_list,
			address_list: state => state.user.address_list,
			examine_list: state => state.user.examine_list,
			jurisdiction: state => state.user.jurisdiction,
			balance: state => state.call.balance
		}),
		components: {
			centerTitle: () => import("@/components/center/centerTitle"),
			memberTable: () => import("@/components/center/memberTable"),
			memberAdd: () => import("@/components/center/memberAdd"),
			memberDialog: () => import("@/components/center/memberDialog"),
			memberForm: () => import("@/components/center/memberForm")
		},
		methods: {
			...mapMutations([
				'handleDialog',
				'setMemberList',
				'setCharacter',
				'setMemberCompany',
				'setMemberDepartment',
				'setAddressList',
				'setMemberExamine',
				'setJurisdiction',
				'setBalance'
			]),
			...mapActions([
				'getMemberList',
				'getMemberDetail',
				'getCharacter',
				'getMemberCompany',
				'getMemberDepartment',
				'getAddressList',
				'getMemberExamine',
				'getJurisdiction',
				'getBranchBalance',
				'getDepartmentBalance',
				'handleValidateUname',
				'exportMemberExcel',
				'handleDelAddress',
				'handleAddMember',
				'handleModifyMember',
				'handleDelMember'
			]),
			// 查
			initData(search, attr, mode, page = 1) {
				// 此处包含一隐藏bug，如果地址列表获取接口resolved迟于成员列表接口，页码显示会变成地址列表页码
				// 页码应该单独出来
				this.getCharacter()
				this.getMemberCompany()
				this.getJurisdiction()
				// new Promise((resolve, reject)=>{
				// 	this.getAddressList({});
				// 	this.getAddressList({}).then((res)=>{
				// 		if(res===true){
				// 			resolve();
				// 		}
				// 	})
				// }).then((res) => {
				// 	this.getMemberData(search, attr, mode, page)//成员列表接口
				// })
				this.getAddressList({all:'all'});
				this.getMemberData(search, attr, mode, page)//成员列表接口
			},
			getMemberData(search, attr, mode, page = 1) {
				let branch_id = this.user_info.branch_id || 0;
				this.getBranchBalance(branch_id)
				this.getMemberDepartment()
				this.getMemberList({
					search,
					attr,
					mode,
					page
				})
				
			},
			changeRouter(search, attr, mode, page = 1) {
				this.$router.push({
					name: 'member',
					query: {
						search,
						attr,
						mode,
						page
					}
				}).catch(err => err)
			},
			handleExport() {
				let list = this.selectedList.map(element => {
					return element.id
				});
				// if(list.length==0){
				// 	this.$message({
				// 		showClose: true,
				// 		message: '請選擇導出用戶',
				// 		type: "error"
				// 	})
				// 	return
				// }
				let id = list.join();
				this.exportMemberExcel({
					id
				})
					.then(res => {
						// console.log(res)
						if (res.code == 1) {
							let url = res.excel
							try {
								var elemIF = document.createElement("iframe");
								elemIF.src = url;
								elemIF.style.display = "none";
								document.body.appendChild(elemIF);
							} catch (e) {
								alert("下载异常！");
							}
							// window.open(res.excel)
						}
					})
			},
			selectedCompany(character_id, branch_id, department_id, user_id) {
				this.getMemberDepartment(branch_id);
				this.getMemberExamine({
					character_id,
					branch_id,
					department_id,
					user_id
				})
				this.getDepartmentBalance({
					branch_id,
					department_id
				});
			},
			selectedDepartment(character_id, branch_id, department_id, user_id) {
				this.getDepartmentBalance({
					branch_id,
					department_id
				})
				this.getMemberExamine({
					character_id,
					branch_id,
					department_id,
					user_id
				})
			},
			handleAssign(character_id, branch_id, department_id, user_id, need) {
				if (need) {
					this.getMemberExamine({
						character_id,
						branch_id,
						department_id,
						user_id
					})
				} else {
					this.setMemberExamine([])
				}
			},
			// 删
			handleDel(res) {
				if (res) {
					this.$message({
						showClose: true,
						message: this.$t("public.delSucc"),
						type: "success"
					})
					setTimeout(() => {
						this.getMemberData(this.search, this.sortAttr, this.sortMode, this.$route.query.page);
					}, 1000)
				} else if(res==false) {
					this.$message({
						showClose: true,
						message: '有未审批订单或报价单，无法删除用户',
						type: "warning"
					})
					
					// delete Address fail and do something
				}
			},
			handleBatchDel() {
				this.$confirm(this.$t("message.cmember.isDel"), {
					confirmButtonText: this.$t("public.confirmBtn"),
					cancelButtonText: this.$t("public.cancelBtn"),
					type: 'warning'
				}).then(() => {
					let list = this.selectedList.map(element => {
						return element.id
					});
					if(list.length==0){
						this.$message({
							showClose: true,
							message: '請選擇刪除用戶',
							type: "error"
						})
						return
					}
					let id = list.join();
					return this.handleDelMember(id)
				}).then((res) => {
					this.handleDel(res)
				}).catch(() => {
					
				})
			},
			selectedAddressDel(id) {
				this.handleDelAddress(id)
					.then(res => {
						if (res) {
							this.$message({
								showClose: true,
								message: this.$t("public.delSucc"),
								type: "success"
							})
							this.getMemberDetail(this.member_detail.id)
						}
					})
			},
			// 增
			handleSubmit(form, rule) {
				console.log(form,'查看')
				rule.memberForm.validate()
					.then(valid => {
						if (!valid) return;
						let flow = [];
						form.flow.map(item => {
							flow.push({
								user_id: item
							})
						})
						return this.handleAddMember({
							personal_sn:form.personal_sn,
							character_id: form.character_id,
							user_id: form.u_id,
							username: form.u_name,
							password: form.pwd,
							email: form.email,
							truename: form.truename,
							market: form.market,
							branch_id: form.branch_id,
							department_id: form.department_id,
							powers: form.powers,
							address: form.address,
							quote_status: form.quote_status,
							jurisdiction: form.jurisdiction,
							flow,
							approval_amount: form.limit_exceed,
							limit_amount: form.limit_amount,
							limit_min_amount: form.limit_min_amount,
							monthly_amount: form.limit_month,
							accumulative_type: form.accumulative_type ? 1 : 0,
							order_status: form.order_status
						})
					}).then(res => {
						let msg = '',
							type = 'success';
						switch (res.type) {
							case 1:
								msg = this.$t("public.addSucc");
								this.addForm = this.addForm == 0 ? 1 : 0;
								this.getMemberData(this.search, this.sortAttr, this.sortMode, this.$route.query.page)
								break;
							case 4:
								msg = this.$t("message.cmember.errmsg2");
								type = 'error';
								break;
							default:
								msg = res.msg;
								type = 'warning';
								break;
						}
						this.$message({
							showClose: true,
							message: msg,
							type
						})
					}).catch(err => console.log(err))
			},
			// 改
			handleCloseDialog() {
				this.handleDialog(false);
				// 清空详情数据
				this.editForm = this.editForm == 0 ? 1 : 0;
				this.getMemberData(this.search, this.sortAttr, this.sortMode, this.$route.query.page);
			},
			//判断是否符合条件
			filterData(data,params1,params2) {
				let _data = data.filter(item => item.address === params1 && item.consignee === params2)
				// console.log(_data,'查看1')
				return _data.length>0?false:true
			},
			//过滤符合条件的数组出来
			Arrayjudgment(){
				let _data = this.$refs.editForm.form.address.filter(item =>  this.filterData(this.member_detail.address,item['address'],item['consignee'] ))
				return _data 
			},
			handleModify(handleClose) {
				this.$refs.editForm.form.address = this.Arrayjudgment();
				// console.log(this.$refs.editForm.form.address,'查看2')
				let form = this.$refs.editForm.form,
					rule = this.$refs.editForm.$refs;

				rule.memberForm.validate()
					.then(valid => {
						if (!valid) return;
						let flow = [];
						form.flow.map(item => {
							flow.push({
								user_id: item
							})
						})
						return this.handleModifyMember({
							personal_sn:form.personal_sn,
							character_id: form.character_id,
							user_id: form.u_id,
							username: form.u_name,
							password: form.up_pwd,
							email: form.email,
							truename: form.truename,
							market: form.market,
							branch_id: form.branch_id,
							department_id: form.department_id,
							powers: form.powers.length == 0?'':form.powers,
							address: form.address,
							quote_status: form.quote_status,
							jurisdiction: form.jurisdiction,
							flow,
							flow_id: form.flow_id,
							approval_amount: form.limit_exceed,
							limit_amount: form.limit_amount,
							limit_min_amount: form.limit_min_amount,
							monthly_amount: form.limit_month,
							accumulative_type: form.accumulative_type ? 1 : 0,
							order_status: form.order_status
						})
					}).then(res => {
						let msg = '',
							type = 'success';
						switch (res.type) {
							case 1:
								msg = this.$t("public.addSucc");
								handleClose();
								break;
							case 4:
								msg = this.$t("message.cmember.errmsg2");
								type = 'error';
								break;
							default:
								msg = res.msg;
								type = 'warning';
								break;
						}
						this.$message({
							showClose: true,
							message: msg,
							type
						})
					}).catch(err => console.log(err))
			}
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				setTimeout(() => {
					let allow = vm.power.includes(0) || vm.power.includes(5);
					
					let {
						search = '',
							attr = '',
							mode = '',
							page = 1
					} = to.query;
					
					if (!allow) {
						vm.$router.back();
						return false;
					}
					
					vm.initData(search, attr, mode, page)
				}, 500)
			})
		},
		beforeRouteUpdate(to, from, next) {
			let {
				search,
				attr,
				mode,
				page
			} = to.query;

			// 路由参数更改，只刷新表格数据
			this.getMemberList({
				search,
				attr,
				mode,
				page
			});
			next();
		},
		beforeRouteLeave(to, from, next) {
			this.setMemberList([]);
			this.setCharacter([]);
			this.setMemberCompany([]);
			this.setMemberDepartment([]);
			this.setAddressList([]);
			this.setMemberExamine([]);
			this.setJurisdiction([]);
			this.setBalance(0);
			next();
		}
	}
</script>
